const autocompleteModalFilterEquip = {
  groups: 'Grupo',
  place: 'Local',
  area: 'Departamentos',
  company: 'Empresa Terceira',
  equipmentModel: 'Tipo do Equipamento',
  site: 'Sites',
  status: 'Status'
};

export default autocompleteModalFilterEquip;
